import React, { useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import _ from "lodash";
import PromoBannerGamePage from "./PromoBannerGamePage";
import queryString from "query-string";
import { SendGuiDataEvents } from "../commonScript";
import { redirectToSubUrl } from "../utils";
import config, { getHeaders } from "../config";
import { reactLocalStorage } from "reactjs-localstorage";
import HomeLoader from "../AppComponents/HomeLoader";

function SingleGame({ btn_color, play_btn_txt, games, sub_url }) {
  const [loading, setLoading] = useState(true);
  const [game, setGame] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const { id, title } = useParams();
  let { search } = useLocation();
  const { rcid, camp ,uid} = queryString.parse(search);
  const history = useHistory();
  const whiteListedArray = ["113", "121", "105", "102", "123"];
  const gamePlayEvent = async (targetGame) => {
    if (!targetGame) {
      console.error("Game object is null in gamePlayEvent");
      return;
    }
    console.log("gamePlayEvent is active");
    let guiPlayEvents = {};
    guiPlayEvents["w_action"] = "promo_game_visit";
    guiPlayEvents["game_name"] = targetGame?.gameName;
    guiPlayEvents["game_id"] = targetGame?.id;
    guiPlayEvents["game_category"] = targetGame?.category;
    await SendGuiDataEvents(guiPlayEvents);
    setTimeout(() => {
      window.open(targetGame?.url, "_self");
    }, 2000);
  };
  const checkSub = async (payload, targetGame=game) => {
    try {
      setLoading(true);
      const url = `${config.get("base")}${config.get("checkSub")}`;
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ ...payload }),
        headers: getHeaders(),
      });

      if (!response.ok) {
        console.log("API request failed with status:", response.status);
        return;
      }
      const result = await response.json();
      console.log("checkSub result::", result);
      if (result.subStatus === "active") {
        console.log("status is active");
        if(uid || result?.uid)
        {
          reactLocalStorage.set("uid",uid || result?.uid)
        }
        if(result?.msisdn)
        {
           reactLocalStorage.set("msisdn",result?.msisdn)
        }
        gamePlayEvent(targetGame);
      } else {
        console.log("status is not active");
        setLoading(false);
        redirectToSubUrl(sub_url, rcid, camp,game.id,game.category)
      }
    } catch (error) {
      console.error("Error checking sub:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (camp) {
      localStorage.setItem("camp", camp);
      sessionStorage.setItem("camp", camp);
    }
    if (rcid) {
      localStorage.setItem("rcid", rcid);
      sessionStorage.setItem("rcid", rcid);
    }
  }, []);

  useEffect(() => {
    if (games && Object.keys(games).length > 0) {
      const allGames = [];
      Object.keys(games).forEach((categoryKey) => {
        if (
          games[categoryKey].contents &&
          Array.isArray(games[categoryKey].contents)
        ) {
          allGames.push(...games[categoryKey].contents);
        }
      });
      const slugify = (text) => {
        return text
          .toString()
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-") // Replace spaces with -
          .replace(/[^\w\-]+/g, "") // Remove all non-word chars
          .replace(/\-\-+/g, "-"); // Replace multiple - with single -
      };

      // Filter game based on both id and title (gameName)
      const foundGame = _.find(allGames, (obj) => {
        const matchId = parseInt(obj.id) === parseInt(id);
        const slugifiedGameName = slugify(obj.gameName);
        const matchTitle = slugifiedGameName === title?.toLowerCase();
        // Return true if either ID or title matches
        return matchId || matchTitle;
      });

      if (foundGame) {
        // Check if the game ID is in the whitelist
        if (whiteListedArray.includes(String(foundGame.id))) {
          console.log(">>>Found whitelisted game:::", foundGame);
          setGame(foundGame);
          setNotFound(false);
          let guiPageOpenEvent = {};
          guiPageOpenEvent["w_action"] = "promo_game_page_open";
          guiPageOpenEvent["game_name"] = foundGame.gameName;
          guiPageOpenEvent["game_id"] = foundGame.id;
          guiPageOpenEvent["game_category"] = foundGame.category;
          SendGuiDataEvents(guiPageOpenEvent);
          if (uid) {
            console.log("UID found, checking subscription...");
            checkSub({ uid: uid || reactLocalStorage.get("uid") }, foundGame);
            // We do NOT set loading(false) here, because checkSub needs time to finish
         } else {
            // Only turn off loading if we aren't waiting for a sub check
            setLoading(false);
         }
        } else {
          console.log(
            ">>>Game not in whitelist, redirecting to home:::",
            foundGame.id
          );
          redirectToSubUrl(sub_url, rcid, camp,foundGame.id,foundGame.category);
        }
      } else {
        console.log(">>>No game found for id:", id, "title:", title);
        setGame(null);
        setNotFound(true);
      }
    } else {
      // No games data available yet
      setLoading(false);
      setNotFound(true);
    }
  }, [games, id, title,history,uid]);

  return (
    <>
      {loading ? (
        <HomeLoader />
      ) : notFound ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
            fontSize: "24px",
            color: "#fff",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <h2>No Game Found</h2>
          <p style={{ fontSize: "16px", marginTop: "10px", opacity: 0.8 }}>
            The game you're looking for doesn't exist or has been removed.
          </p>
        </div>
      ) : (
        <React.Fragment>
          {game && (
            <div>
              <PromoBannerGamePage
                game={game}
                color={btn_color}
                play_btn_txt={play_btn_txt}
                loading={loading}
                showBackIcon={false}
                setLoading={setLoading}
                sub_url={sub_url}
                gamePlayEvent={gamePlayEvent}
                checkSub={checkSub}
              />
            </div>
          )}
        </React.Fragment>
      )}
    </>
  );
}

export default SingleGame;
